import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import piHomeCard from "../pi-home-card/pi-home-card.vue";
import piButtonSelect from "@/components/pi-button-select/pi-button-select.vue";
import piNoData from "@/components/pi-no-data/pi-no-data.vue";
import { getHomeStatRanking } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import { piOhGetProgress } from "@/utils/object.helper";
export const DAY_TYPE = {
    yesterday: "1",
    thisMonth: "2",
    thisYear: "3",
};
let PiHomeSiteRanking = class PiHomeSiteRanking extends Vue {
    constructor() {
        super(...arguments);
        this.piOhGetProgress = piOhGetProgress;
        this.rangeSubject = "2";
        this.period = "3";
        this.selectList = [
            { label: i18n.t("yesterday"), value: DAY_TYPE.yesterday },
            { label: i18n.t("thisMonth"), value: DAY_TYPE.thisMonth },
            { label: i18n.t("thisYear"), value: DAY_TYPE.thisYear },
        ];
        this.No1 = 0;
        this.rankingList = [];
    }
    /**
     * 请求排行版数据
     */
    async getHomeStatRanking() {
        const ret = await getHomeStatRanking({
            period: this.period,
            rangeSubject: this.rangeSubject,
        });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data || [];
            this.rankingList = data;
            if (data[0]) {
                this.No1 = data[0].value;
            }
        }
    }
    mounted() {
        this.getHomeStatRanking();
    }
};
PiHomeSiteRanking = __decorate([
    Component({
        components: {
            "pi-home-card": piHomeCard,
            "pi-button-select": piButtonSelect,
            "pi-no-data": piNoData,
        },
    })
], PiHomeSiteRanking);
export default PiHomeSiteRanking;
